function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-605.000000, -14.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(605.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.772727, 0.622858)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.1559448,2.36916465 C33.1559448,3.01207374 32.7284206,3.53890202 32.20786,3.53890202 L0.945426667,3.53890202 C0.424866061,3.53890202 -0.000443030303,3.01207374 -0.000443030303,2.36916465 L-0.000443030303,1.20389192 C-0.000443030303,0.560982828 0.424866061,0.0341545455 0.945426667,0.0341545455 L32.20786,0.0341545455 C32.7284206,0.0341545455 33.1559448,0.560982828 33.1559448,1.20389192 L33.1559448,2.36916465 Z",
  fill: "#ccc"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.772727, 11.127908)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.1559448,2.37344545 C33.1559448,3.01635455 32.7284206,3.54095051 32.20786,3.54095051 L0.945426667,3.54095051 C0.424866061,3.54095051 -0.000443030303,3.01635455 -0.000443030303,2.37344545 L-0.000443030303,1.2059404 C-0.000443030303,0.565263636 0.424866061,0.0384353535 0.945426667,0.0384353535 L32.20786,0.0384353535 C32.7284206,0.0384353535 33.1559448,0.565263636 33.1559448,1.2059404 L33.1559448,2.37344545 Z",
  fill: "#ccc"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 21.107706)",
  fill: "#ccc"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.9286721,2.90297879 C33.9286721,3.54365556 33.5011479,4.07048384 32.9805873,4.07048384 L1.71815394,4.07048384 C1.19759333,4.07048384 0.772284242,3.54365556 0.772284242,2.90297879 L0.772284242,1.73547374 C0.772284242,1.09256465 1.19759333,0.567968687 1.71815394,0.567968687 L32.9805873,0.567968687 C33.5011479,0.567968687 33.9286721,1.09256465 33.9286721,1.73547374 L33.9286721,2.90297879 Z"
}))))));

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.c1ac76bf.svg";
export { ForwardRef as ReactComponent };